import React, { Component } from 'react'
import NumberFormat from 'react-number-format'
import { Redirect } from 'react-router-dom'
import moment from 'moment'
import { IMAGE_THUMB_URL, PAGE10, BASE_DIR } from '../../../config/config'
import CarLeasingView from '../CarLeasingView'

class CarRow extends Component {

  constructor (props) {
    super(props);
    this.state = {
      'btnClick': '',
      'carSelect': 0,
      car_id: '',
      upload_code: '',
      carcalculate: false,
      carLeasingList: [],
      cars: [],
      car_explain: {},
      page: 0,
      count: 0,
    }
  }

  toQueryString (paramsObject) {
    return Object
      .keys(paramsObject)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`)
      .join('&')

  }

  handleOnClick (action, car, car_sell) {

    var search3 = this.toQueryString(car)

    this.setState({
      'btnClick': action,
      'carSelect': search3,
      'car_id': car.car_id,
      'upload_code': car.car_upload_code,
    })

    if (action === 'car-edit-status') {
      this.props.onCarStatusEdit(car)
    } else if (action === 'car-calculate') {
      this.props.onCarCalculate(car)
    } else if (action === 'car-share') {
      //alert(car.car_share)
      this.props.onCarShare(car)
    } else if (action === 'car-delete') {
      this.props.onCarDelete(car)
    } else if (action === 'car-leasing'){
      this.props.onCarLeasing(car)
    } else if (action === 'car-edit-sell-price') {
      this.props.onCarEditSellPrice(car)
    }

  }

  componentDidMount() {
    this.setState({
      cars: this.props.cars,
      page: this.props.page,
      count: this.props.count
    });
  }

  componentWillReceiveProps(nextProps) {

    if(nextProps.carLeasingList.length === 0 && this.props.carLeasingList.length === 0 ) {
      this.setState({carLeasingList: []});
    }else if(nextProps.carLeasingList !== this.props.carLeasingList) { // && this.props.carLeasingList.length === 0
      if (nextProps.carLeasingList.length > 0 ) {
        this.setState({
          carLeasingList: nextProps.carLeasingList
        })
      }else{
        this.setState({carLeasingList: []});
      }
    }

    if(nextProps.cars !== this.props.cars) {
        this.setState({
          cars: nextProps.cars,
          page: nextProps.page,
          count: nextProps.count
        });
    }
  }

  /* shouldComponentUpdate(nextProps, nextState) {
    console.log('shouldComponentUpdate CarRow')
    console.log(nextProps.carLeasingList)
    return this.props.carLeasingList !== nextProps.carLeasingList || nextState.input !== this.state.input
  } */

   /* carExpenseCal(car) {


  } */

  render () {

    var target = '';
    if (this.state.btnClick === 'car-repair') {
       target = '/car-repair/new?car_id=' + this.state.car_id
      return <Redirect push to={target}/>
    } else if (this.state.btnClick === 'car-detail') {
       target = '/cars/detail/?car_id=' + this.state.car_id
      target += '&upload_code=' + this.state.upload_code
      return <Redirect push to={target}/>
    } else if (this.state.btnClick === 'car-buy') {
       target = '/sales/buy/?car_id=' + this.state.car_id
      return <Redirect push to={target}/>
    } else if (this.state.btnClick === 'car-book') {
       target = '/cars/book/?car_id=' + this.state.car_id
      return <Redirect push to={target}/>

    } else if (this.state.btnClick === 'car-book-cancel') {
       target = '/cars/book-cancel/?car_id=' + this.state.car_id
      return <Redirect push to={target}/>
    }

    var car_all = this.state.count
    var page = this.state.page
    var start_row = 0
    if(car_all > 0  && page > 0){
      start_row = Number(page-1) * PAGE10
    }

    let tbodyList = this.state.cars.map((car, index) => {

      var order = Number(car_all-start_row)-index // 16

      //
      var car_name = car.car_name;
      var car_date_register = "วันที่จดทะเบียน: " + (car.car_date_regis != null && car.car_date_regis !== '0000-00-00' ?  moment(car.car_date_regis).locale('th').format('LL'): '-')

      if(BASE_DIR === 'pisanyontrakan') {
        var car_year_name = car.car_year_name
        // var car_date_regis = moment(car.car_date_regis).format('YYYY');
        // car_date_regis
        // car_name = car.car_brand_name + " " + car.car_sub_model_name + " ปี " + car_date_regis
        // car_name += " "+ car_date_regis; //mo 1 Feb 2020
         car_date_register = "รถปี ค.ศ. "+ car_year_name;
      }

      return (

        <tr className="text-center" key={index}>
          <td>{order}</td>
          <td>
            <div className="row">
              <div className="col-md-12 mt-2">
                <img src={IMAGE_THUMB_URL + car.car_upload_filename} className="img-cars" alt="car"/>
              </div>
            </div>
            <div className="row hidden-md">
              <div className="col col-sm-12 col-md-12 col-lg-12 mt-2">
                <button type="button" onClick={() => this.handleOnClick('car-calculate', car)}
                        className="btn btn-success btn-sm btn-block ">
                  <i className="icon-calculator"></i> ค่างวด
                </button>
              </div>
              <div className="col col-sm-12 col-md-12 col-lg-12 mt-2">
                <button type="button" onClick={() => this.handleOnClick('car-share', car)}
                        className="btn btn-primary btn-sm btn-block ">
                  <i className="icon-share"></i> แชร์
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col col-sm-12 col-md-12 col-lg-12 mt-2 ">
                <textarea
                  id="car_explain"
                  name="car_explain"
                  rows={3}
                  value={car.car_explain}
                  onChange={(e) => this.props.onCarExplainFormEdit(e, car.car_id)}
                  placeholder="บุคคล/vat"
                >

                </textarea>
                <br/>
                <button
                  className={car.car_edit? 'btn btn-sm btn-primary ' : 'hidden'}
                  onClick={()=> this.props.onCarExplainUpdate(car.car_id, car.car_explain )}
                >
                  บันทึก
                </button>
                <div className={car.car_save? 'fadeOut' : 'hidden'}><span className="text-success"> บันทึกเรียบแล้วแล้ว </span></div>

              </div>

              <div className="row">
                <div className="col col-sm-12 col-md-12 col-lg-12 mt-2 ">
                  <strong>วันที่ซื้อรถเข้ามา: {moment(car.car_date_in).format('DD-MM-YYYY')}</strong>

                  <div className="col col-sm-12 col-md-12 col-lg-12 mt-2 text-danger">
                    <strong> ป้ายแดง: {car.plate_red === ''? '-' : car.plate_red} </strong>
                  </div>

                </div>
              </div>

              <div className="row">

              </div>

            </div>

          </td>
          <td className="text-center">
            <strong>{car_name}</strong>
            <br/>
            <strong> ทะเบียนรถ : {car.car_license_plate_new}</strong>
            {
              car.car_license_plate_new !== car.car_license_plate_old ?
                <strong> &nbsp; ทะเบียนเดิม : {car.car_license_plate_old}</strong>
               : null
            }

            &nbsp;&nbsp;
            <span className="badge"
                  style={{backgroundColor: car.car_status_color}}>{car.car_status_name}
            </span>
            {
              car.car_share === 'show' ? <div>
                <br/>
                <img src={'img/if_world.png'} style={{width: 16}}
                     className={car.car_share === 'show' ? '' : 'hidden'}
                     alt="share status"
                />
              </div> : null
            }
            <br/>
            <strong>{car_date_register} </strong>
            &nbsp;&nbsp;
            <span className="badge mt-1"
                  style={{backgroundColor: '#eeb877'}}
            >
              รถจอด : {car.park_location}
            </span>
            <br/>
            <center>
            {/*<CarLeasingView
              car={car}
              carLeasingList={this.state.carLeasingList.length !== 0 && this.state.carLeasingList[0].car_id===car.car_id ? this.state.carLeasingList : []} />*/}

                <CarLeasingView
                  car={car}
                  carLeasingList={this.state.carLeasingList}
                 />

            <button type="button"
                    style={{marginTop: 8}}
                    onClick={() => this.handleOnClick('car-leasing', car)}
                    className="btn btn-outline-danger btn-sm btn-block w-50">
              <i className="icon-diamond"></i> ยอดจัด
            </button>
            </center>

          </td>
          {/*<td className={this.props.user_type === 'admin' ? 'text-center' : 'hidden'}>
            <NumberFormat
            value={car.car_cost} displayType={'text'} thousandSeparator={true} prefix={'฿'}/>
          </td>*/}
          <td className={this.props.user_type === 'technician' ? 'hidden' : ''} >

              <table className="table2">
              <tbody>
                <tr className={this.props.user_type === 'admin' ? 'text-primary' : 'hidden'}>
                  <td className="text-right">ทุนซื้อเข้า:</td>
                  <td className="text-right">
                    <NumberFormat
                      value={car.car_cost}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'฿'}
                    />
                  </td>
                </tr>
                <tr className={this.props.user_type === 'admin' ? 'text-primary' : 'hidden'}>
                  <td className="text-right">ทุนซ่อม/แต่ง:</td>
                  <td className="text-right">
                    <NumberFormat
                      value={car.car_cost_repair}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'฿'}
                    />
                  </td>
                </tr>
                <tr className={this.props.user_type === 'admin' ? 'text-primary' : 'hidden'}>
                  <td className="text-right">ทุนอื่นๆ:</td>
                  <td className="text-right">
                    <NumberFormat
                      value={car.car_cost_other}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'฿'}
                    />
                  </td>
                </tr>

                <tr className={this.props.user_type === 'admin' ? 'text-primary' : 'hidden'}>
                  <td className="text-right">รวมทุน:</td>
                  <td className="text-right">
                    <NumberFormat
                      value={car.car_cost + car.car_cost_repair +car.car_cost_other}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'฿'}
                    />
                  </td>
                </tr>

                <tr>
                  <td className="text-right">ราคาขาย:</td>
                  <td className="text-right">
                    <NumberFormat
                      value={car.car_sale_price}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'฿'}
                    />
                  </td>
                </tr>

                <tr className={this.props.user_type === 'admin' ? 'text-success' : 'hidden'}>
                  <td className="text-right">กำไร:</td>
                  <td className="text-right">
                    <NumberFormat
                      value={car.car_sale_price - (car.car_cost + car.car_cost_repair +car.car_cost_other)}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'฿'}
                    />
                  </td>
                </tr>

              </tbody>
              </table>

          </td>
          {/*
          <CarRowExpense car_id={car.car_id}/>

          <td className={this.props.user_type === 'admin' ? 'text-center' : 'hidden'}>
            <NumberFormat
            value={car.car_net_profit} displayType={'text'} thousandSeparator={true} prefix={'฿'}/>
          </td>
          <td>

          </td>*/}

          <td>

            <button onClick={() => this.handleOnClick('car-detail', car)} type="button"
                    className="btn btn-info btn-sm btn-block"><i className="icon-list">
              &nbsp;รายละเอียดรถ</i>
            </button>
            <button onClick={() => this.handleOnClick('car-repair', car)}
                    type="button"
                    className="btn btn-danger btn-sm btn-block">
              <i className="icon-wrench">
              &nbsp;รายการปรับแต่ง
              </i>
            </button>
            <button
              onClick={() => this.handleOnClick('car-edit-status', car)}
              type="button"
              className={this.props.user_type === 'technician' ? 'hidden' : 'btn btn-warning btn-sm btn-block'}
            >
              <i className="icon-note">
                &nbsp;แก้ไขสถานะ
              </i>
            </button>

            <button
              onClick={() => this.handleOnClick('car-edit-sell-price', car)}
              type="button"
              className={this.props.user_type === 'technician' ? 'hidden' : 'btn btn-danger btn-sm btn-block'}
            >
              <i className="icon-note">
                &nbsp;แก้ไขราคาขาย
              </i>
            </button>

            <button onClick={() => this.handleOnClick('car-book', car)} type="button"
                    className={this.props.user_type === 'technician' ? 'hidden' : 'btn btn-info btn-sm btn-block'}
            >
              <i className="icon-star">
              &nbsp;จองรถคันนี้</i>
            </button>
            {/*<button  onClick={()=>this.handleOnClick('car-book-cancel', car)}  type="button" className={(car.car_status_id === 7)? "btn btn-danger btn-sm btn-block":"btn btn-danger btn-sm btn-block hidden"}><i className="icon-close"> จอง/ยกเลิกการจอง</i></button>*/}
            <button onClick={() => this.handleOnClick('car-buy', car)} type="button"
                    className={this.props.user_type === 'technician' ? 'hidden' : 'btn btn-success btn-sm btn-block'}
            ><i className="icon-trophy">
              &nbsp;ขายรถคันนี้</i>
            </button>

            <button onClick={() => this.handleOnClick('car-delete', car)} type="button"
                    className={this.props.user_type === 'admin'? 'btn btn-danger btn-sm btn-block': 'hidden'}

            ><i className="icon-trash">
              &nbsp;ลบรถคันนี้</i>
            </button>


          </td>
        </tr>
      )
    })

    var tbEmpty = (
      <tr><td colSpan={6} className="text-danger text-center">ไม่พบข้อมูลรถ</td></tr>
    )

   var tbBody = this.state.cars.length===0 ? tbEmpty : tbodyList

    return (
      <tbody>
      {tbBody}
      </tbody>
    )
  }
}

/*const styles = {
   fadeOut: {
     color: '#FFFFFF',
     textAlign: 'center',
     webkitTransition: 'opacity 3s ease-in-out',
     opacity: 1
   }
}*/

export default CarRow;

